<template>
    <div class="loading active">
        <!-- <div class="icon"><i class="fa fa-plane fa-spin"></i></div> -->
        <div class="icon"><i class="fa fa-circle-o-notch fa-spin"></i></div>
    </div>
</template>

<script>
export default {
  name: 'CallBack',
  data: () => ({
    code: '',
    accessToken: ''
  }),
  created () {
    let href = window.location.href
    /* if (href.includes("/?code")) {  //url包括 com/?code 证明为从微信跳转回来的
        var url = href.substring(0, href.length - 10); //vue自动在末尾加了 #/ 符号，截取去掉
        var jingPosit = url.indexOf(".com") + 5; //获取域名结束的位置
        var urlLeft = url.substring(0, jingPosit);//url左侧部分
        console.log('urlLeft',urlLeft)
        var urlRight = url.substring(jingPosit, url.length); //url右侧部分
        console.log('urlRight',urlRight)
        console.log('location----123',urlLeft + "#/" + urlRight)
        window.location = urlLeft + "#/callback" + urlRight;//拼接跳转
      } */
    if (href.includes('/?code')) { // url包括 com/?code 证明为从微信跳转回来的
      var url = href.substring(0, href.length - 10) // vue自动在末尾加了 #/ 符号，截取去掉
      var jingPosit = ''
      if (href.includes('localhost')) {
        jingPosit = url.indexOf('8080') + 5 // 获取域名结束的位置
      } else {
        jingPosit = url.indexOf('.com') + 5 // 获取域名结束的位置
      }
      var urlLeft = url.substring(0, jingPosit) // url左侧部分
      console.log('urlLeft', urlLeft)
      var urlRight = url.substring(jingPosit, url.length) // url右侧部分
      console.log('urlRight', urlRight)
      console.log('location----', urlLeft + '#/' + urlRight)
      window.location = urlLeft + '#/callback' + urlRight // 拼接跳转
    }
    this.code = this.$route.query.code
    // console.log('code', this.$route.query.code)
  },
  watch: {
    code: function () {
      this.getAccessToken(this.code)
        .then(resp => {
          const token = resp.data.access_token
          const refreshToken = resp.data.refresh_token
          localStorage.removeItem('access_token')
          // sessionStorage.setItem('account', '1802194')
          // sessionStorage.setItem('account', param.account.split('@')[0])
          this.accessToken = 'Bearer ' + token
          localStorage.setItem('access_token', 'Bearer ' + token)
          localStorage.setItem('refresh_token', refreshToken)
          // this.$router.push({
          //   path: '/home'
          // })
          this.getUserProfile(localStorage.getItem('access_token'))
            .then(resp => {
              // this.mail = resp.data.mail
              // this.displayName = resp.data.displayName
              localStorage.setItem('mail', resp.data.mail)
              localStorage.setItem('displayName', resp.data.displayName)
              this.$router.push({
                path: '/'
              })
            })
            .catch(err => {
              console.log('err', err)
            })
        })
        .catch(err => {
          console.log('err', err)
        })
    }
  }
}
</script>
